import { Button, Form, Input } from "antd";
import { FormattedMessage, useIntl } from "react-intl";

import { PaymentTerminalFormProps, PaymentTerminalFormValues } from "./types";
import { paymentFormLayout } from "./consts";

const PaymentTerminalForm: React.FC<PaymentTerminalFormProps> = ({
  loading,
  ...props
}) => {
  const intl = useIntl();

  return (
    <Form<PaymentTerminalFormValues> {...paymentFormLayout} {...props}>
      <Form.Item
        label={intl.formatMessage({ defaultMessage: "Name" })}
        name={["input", "name"]}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={intl.formatMessage({ defaultMessage: "Registration Code" })}
        name={["input", "stripeTerminalRegistrationCode"]}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" {...{ loading }}>
          <FormattedMessage defaultMessage="Submit" />
        </Button>
      </Form.Item>
    </Form>
  );
};

export default PaymentTerminalForm;
